var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 35,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4264FD",
  fillRule: "evenodd",
  d: "M15.674 25.5c.524 0 .933-.21 1.217-.648l8.316-13.208c.213-.329.293-.62.293-.903 0-.721-.515-1.241-1.235-1.241-.497 0-.8.182-1.102.675L15.64 22.417 11.783 17.4c-.293-.374-.595-.538-1.03-.538-.729 0-1.253.529-1.253 1.258 0 .32.107.62.364.94l4.602 5.82c.338.428.71.62 1.208.62",
  clipRule: "evenodd"
})));
export default SvgIconCheck;